<template>
  <!--  解决方案-->
  <div class="container">
    <Nav></Nav>
    <div class="index_hearderImg">
      <img src="../assets/qingye/PlanSmartCity.png" alt="" />
    </div>
    <div class="breadcrumb_center">
      <el-breadcrumb
        class="el-icon-arrow-right"
        separator-class="el-icon-arrow-right"
      >
        <img src="../assets/qingye/indexImg.png" alt="" />
        <div>
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>解决方案</el-breadcrumb-item>
          <el-breadcrumb-item>{{ PlanName }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>
    <div class="BusinessCooperation index_center">
      <!--<div class="BusinessCooperation_nav">-->
      <div class="NavMenu">
        <el-tabs v-model="tabIndex" @tab-click="tabClick">
          <el-tab-pane
            :label="item.type"
            :name="item.id + ''"
            v-for="(item, index) in planTypeList"
            :key="index"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <!--</div>-->
      <div class="BusinessCooperation_content flex_col">
        <div class="PlanSmartCity">
          <div class="PlanSmartCity_content">
            <div
              class="PlanSmartCity_content_img"
              v-for="(item, index) in planList"
              @click="openDetail(item.id)"
              :key="index"
            >
              <img :src="item.imageUrl" alt="" />
              <div class="SmartCity_content_name">{{ item.title }}</div>
              <div class="SmartCity_content_name1">{{ item.summary }}</div>
            </div>
          </div>
        </div>
        <Paging
          :total="total"
          @onPageChange="onPageChange"
          :current-page="pageNumber"
        ></Paging>
      </div>
    </div>
    <submit-from></submit-from>
    <Foot style="margin-top: 100px"></Foot>
  </div>
</template>
<script>
import Nav from "./components/navBar";
import Foot from "./components/Foot";
import SubmitFrom from "./components/SubmitFrom";
import Paging from "./components/Paging";
import { getPlanTypeApi, getPlanListApi } from "@/api/index";
export default {
  components: {
    Nav,
    Foot,
    SubmitFrom,
    Paging,
  },
  name: "BusinessCooperation",
  data() {
    return {
      PlanName: "",
      planList: [],
      planTypeList: [],
      tabIndex: "",
      pageSize: 10,
      pageNumber: 1,
      total: 0,
      tablist: 0,
    };
  },

  mounted() {
    this.getPlanType();
  },
  methods: {
    //分页
    onPageChange(val) {
      console.log(val);
      this.pageNumber = val;
      this.getPlanList();
    },
    //tab切换
    tabClick(tab) {
      this.pageNumber = 1;
      this.tablist = tab.index;
      console.log(tab.index);
      this.getPlanList();
      this.getPlanType();
    },
    // 解决方案详情
    openDetail(id) {
      this.$router.push({
        path: "/detail",
        name: "detail",
        query: {
          id: id,
          type: 4,
        },
      });
    },
    //获取商品列表
    getPlanList() {
      var data = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        type: this.tabIndex,
      };
      getPlanListApi(data).then((res) => {
        console.log(res);
        this.planList = res.data.list;
        this.total = res.data.totalCount;
      });
    },
    //获取商品类型
    getPlanType() {
      getPlanTypeApi().then((res) => {
        console.log(res);
        this.planTypeList = res.data;
        this.PlanName = this.planTypeList[this.tablist].type;
        this.tabIndex = this.planTypeList[this.tablist].id + "";
        this.getPlanList();
      });
    },
  },
};
</script>
<style scoped>
.index_center {
  margin: 0 auto;
  width: 1200px;
}

.breadcrumb_center {
  width: 100%;
  background-color: #f6f7f8;
  display: flex;
  justify-content: space-around;
  height: 50px;
}
.el-icon-arrow-right {
  display: flex;
  align-items: center;
  width: 1200px;
  color: #666666;
}
.el-icon-arrow-right img {
  padding: 0 10px 0px 0;
}
.index_hearderImg {
  display: flex;
  justify-content: center;
}
.index_hearderImg img {
  width: 100%;
}
div /deep/ .el-breadcrumb__inner.is-link {
  font-weight: normal;
  color: #606266;
}

/*------------*/
.BusinessCooperation {
  margin-top: 70px;
}
.BusinessCooperation_nav {
  display: flex;
  justify-content: center;
}

.index_hearderImg {
  display: flex;
  justify-content: center;
}

/*------------------------------------*/

.BusinessCooperation >>> .el-tabs__header {
  margin: 0px !important;
}

.BusinessCooperation >>> .el-tabs__nav-wrap::after {
  height: 0px;
}

.BusinessCooperation .BusinessCooperation_content1 {
  margin-top: 42px;
  justify-content: space-between;
}

.BusinessCooperation_content1 .left {
  width: 694px;
  height: 460px;
  background: #f6f6f6;
}

.BusinessCooperation_content1 .service_li {
  width: 204px;
  height: 180px;
  margin-left: 20px;
  margin-top: 15px;
  background: white;
}

.BusinessCooperation_content1 .service_li .txt {
  height: 32px;
  width: 100%;
  color: white;
  text-align: center;
  font-size: 18px;
  line-height: 32px;
}

.BusinessCooperation_content1 .property {
  background: #f6f6f6;
  height: 234px;
}

.BusinessCooperation_content1 .right {
  width: 280px;
  height: 460px;
  background: #f6f6f6;
}

.BusinessCooperation_content1 .title {
  padding: 15px 10px 10px 10px;
  width: 200px;
  box-sizing: border-box;
  border-bottom: 3px solid #1b63a7;
  font-size: 20px;
  color: #1b63a7;
  align-items: center;
}

.BusinessCooperation_content1 .title img {
  height: 15px;
  width: auto;
}

.BusinessCooperation_content1 .title p {
  margin-left: 10px;
}

.BusinessCooperation_content1 .left .list {
  justify-content: center;
  padding: 14px 25px;
  box-sizing: border-box;
  width: 100%;
}

.BusinessCooperation_content1 .left .list .li {
  height: 40px;
  width: 100%;
  line-height: 40px;
  justify-content: space-between;
  font-size: 16px;
  border-bottom: 1px #666666 dashed;
}

.BusinessCooperation_content1 .left .list .li .le {
  color: #666666;
  width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.BusinessCooperation_content1 .left .list .li .ri {
  color: #999999;
}

.BusinessCooperation_content1 .left .more {
  color: #1b63a7;
  font-size: 14px;
  text-align: right;
  margin-top: 20px;
}

.BusinessCooperation_content1 .right .list {
  margin-top: 20px;
  flex-wrap: wrap;
  padding: 0px 10px;
  box-sizing: border-box;
}

.BusinessCooperation_content1 .right .list p {
  padding: 6px 10px;
  color: #1b63a7;
  font-size: 16px;
  border: 1px solid #1b63a7;
  border-radius: 15px;
  align-items: center;
  margin-bottom: 10px;
}

.BusinessCooperation_content1 .other {
  margin-top: 20px;
}

.BusinessCooperation_content1 .other p {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 5px;
}

.other div {
  margin: 0 auto;
}

.property .list {
  padding: 20px;
}

.property_list .li {
  text-align: center;
}

.property_list p {
  margin-top: 20px;
}

.paging >>> .el-pagination {
  padding: 0px;
}

.paging >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #1b63a7;
  border: 1px solid #1b63a7;
}

.paging >>> .el-pagination.is-background .btn-next,
.paging >>> .el-pagination.is-background .btn-prev,
.paging >>> .el-pagination.is-background .el-pager li {
  background-color: white;
  border: 1px solid #e8e8e8;
}

.paging >>> .el-pager li {
  line-height: 27px;
}

/*.BusinessCooperation_tab_title_list img {*/
/*  padding-right: 35px;*/
/*  !*margin-right: 65px;*!*/
/*}*/

.BusinessCooperation_tab_title_p_name {
  padding-top: 10px;

  /*超出部分用省略号表示*/
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  -webkit-line-clamp: 5;
  overflow: hidden;
}

.PlanSmartCity_content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding-top: 90px;
}
.PlanSmartCity_content:after {
  content: "";
  width: 33.33%;
}
.PlanSmartCity_content_img {
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  /*align-items: center;*/
  cursor: pointer;
  width: 360px;
}
/* .PlanSmartCity_content_img img {
  box-shadow:0 0px 8px rgba(0, 0, 0, 0.2);
} */
.PlanSmartCity_content_name {
  padding-top: 13px;
  font-size: 16px;
  color: #333333;
  padding-left: 12px;
}
.PlanSmartCity_content_name1 {
  padding-top: 13px;
  font-size: 14px;
  color: #999999;
  padding-left: 12px;
}
.SmartCity_page {
  padding-top: 87px;
  width: 1200px;
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/views/BusinessCooperation.vue